import _ from "lodash";

const initialState = {
  form: [],
  approver: []
};

const formArray = (state = initialState, action) => {
  switch (action.type) {
    case "RECEIVE_FORM_ARRAY":
      let element = _.filter(state.form, { formId: action.formId });

      if (element.length === 1) {
        return {
          ...state,
          form: state.form.map(formControls =>
            formControls.formId === action.formId
              ? { data: action.formControls, formId: action.formId }
              : formControls
          )
        };
      } else {
        return {
          ...state,
          form: [
            ...state.form,
            { data: action.formControls, formId: action.formId }
          ]
        };
      }
    case "RECEIVE_APPROVER_ARRAY":
      let elementA = _.filter(state.approver, { formId: action.formId });

      if (elementA.length === 1) {
        let replacedItemIndexA = _.findIndex(state.approver, {
          formId: action.formId
        });

        return Object.assign({}, state, {
          approver: [
            ...state.approver.slice(0, replacedItemIndexA),
            {
              data: action.approvers,
              formId: action.formId
            },
            ...state.approver.slice(replacedItemIndexA + 1)
          ]
        });
      } else {
        return {
          ...state,
          approver: [
            ...state.approver,
            { data: action.approvers, formId: action.formId }
          ]
        };
      }
    case "RESET_FORM_ARRAY":
      return Object.assign({}, state, {
        form: []
      });
    default:
      return state;
  }
};

export default formArray;



// WEBPACK FOOTER //
// ./src/reducers/formArray.js